
import { ISanPhamImportResponse } from "../../../model/respone/common/ISanPhamImportResponse";
import { ISanPhamActions } from "../../action-types/san-pham/ISanPhamActionType";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ISanPhamReducer } from "../../reducer-model/san-pham/ISanPhamReducer";
const iniState: ISanPhamReducer = {
    status: eReducerStatusBase.is_not_initialization,
    sanPhams: [],
    categorySelectedId: 0,
    sanPhamImports: {} as ISanPhamImportResponse
}
export const sanPhamReducer = (state: ISanPhamReducer = iniState, action: ISanPhamActions): ISanPhamReducer => {
    switch (action.type) {
        case "SAN_PHAM_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "SAN_PHAM_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                sanPhams: action.payload
            }
        case "SAN_PHAM_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                sanPhamSelectedId: 0,
                sanPhamEditing: action.payload
            }
        case "SAN_PHAM_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
            }
        case "SAN_PHAM_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SAN_PHAM_SAVE_SUCCESS":
            return {
                ...state,
                isShowEditModal: false,
                status: eReducerStatusBase.is_need_reload,
                sanPhamSelectedId: 0
            }
        case "SAN_PHAM_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "SAN_PHAM_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "SAN_PHAM_CHANGE_SELECTED_ID":
            return {
                ...state,
                sanPhamSelectedId: action.payload
            }
        case "SAN_PHAM_CHANGE_CATEGORY_SELECTED_ID":
            return {
                ...state,
                categorySelectedId: action.payload
            }
        case "SAN_PHAM_SHOW_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: true,
            }
        case "SAN_PHAM_CLOSE_IMPORT_MODAL":
            return {
                ...state,
                isShowImportModal: false,
            }
        case "SAN_PHAM_SAVE_IMPORT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "SAN_PHAM_SAVE_IMPORT_SUCCESS":
            return {
                ...state,
                // isShowImportModal: false,
                sanPhamImports: action.payload,
                status: eReducerStatusBase.is_need_reload
            }
        case "SAN_PHAM_SAVE_IMPORT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return state;
    }
}